import React from "react";
import PointSystemGeneralInfo from "../GeneralInfo";
import CardContainer from "../../../../components/Common/CardContainer";
import ButtonInput from "../../../../components/Common/ButtonInput";
import * as BootstrapVariants from "../../../../constants/Bootstrap/Variants";

const PointSystemDetails = (props) => {
  const handleReturn = () => {
    props.history.push(`/pointSystems`);
  };
  return (
    <CardContainer
      header={"Point System Details"}
      backButton={
        <ButtonInput
          label="Back to List"
          type="button"
          variant={BootstrapVariants.OutlineSecondary}
          onClick={() => handleReturn()}
        />
      }
    >
      <PointSystemGeneralInfo
        pointSystemId={props.match.params.pointSystemId}
      />
    </CardContainer>
  );
};

export default PointSystemDetails;
